// Simple AI client for frontend to call the backend proxy at /api/generate
function initAI() {
  const sendBtn = document.getElementById('ai-send');
  const clearBtn = document.getElementById('ai-clear');
  const promptEl = document.getElementById('ai-prompt');
  const resultEl = document.getElementById('ai-result');
  const openSim = document.getElementById('open-sim');

  if (openSim) {
    openSim.addEventListener('click', () => {
      // Scroll to simulation area and focus
      const sim = document.getElementById('sim-area');
      if (sim) {
        window.scrollTo({ top: sim.offsetTop, behavior: 'smooth' });
      }
    });
  }

  if (!sendBtn) return;

  sendBtn.addEventListener('click', async () => {
    const prompt = promptEl.value.trim();
    if (!prompt) return;
    resultEl.textContent = 'Thinking...';
    try {
      const res = await fetch('/api/generate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt }),
      });
      if (!res.ok) throw new Error('AI request failed');
      const data = await res.json();
      resultEl.textContent = data.response || JSON.stringify(data, null, 2);
    } catch (err) {
      resultEl.textContent = `Error: ${err.message}`;
    }
  });

  clearBtn.addEventListener('click', () => {
    promptEl.value = '';
    resultEl.textContent = 'No response yet';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAI);
} else {
  // DOM already ready (likely because React rendered after script executed)
  initAI();
}

export {};
